import React from "react"
import { Input, Button, Table, Space, Form } from 'antd'
import { FormInstance } from "antd/lib/form"
import Modal from "antd/lib/modal/Modal"
import { SearchOutlined, RedoOutlined } from '@ant-design/icons'
import { axiosTable, baseAxiosComplete, baseAxiosNoInfo } from '../../tool/axios'
import BreadCrumb from '../../component/BreadCrumb'
import getPermission from '../../js/permission'
import { formItemLayout, tailLayout } from '../../js/globalParam'

const { Column } = Table

interface State {
    data: object[],
    loading: boolean,
    pagination: {
        current: number,
        pageSize: number,
        total: number,
        showSizeChanger: boolean
    },
    fetchOtherParams: {
        item_type_name: string | undefined
    },
    formParams: {
        item_type: string | null
    },
    offShelfVisible: boolean,
    addVisible: boolean,
    detailModalVisible: boolean,
    visibleTitle: string,
    activeRecordID: number | null,
    permissionList: string[]
}

export default class CkProjectType extends React.Component {

    state: State = {
        data: [],
        loading: false,
        pagination: {
            current: 1,
            pageSize: 8,
            total: 0,
            showSizeChanger: false
        },
        fetchOtherParams: {
            item_type_name: undefined
        },
        formParams: {
            item_type: null
        },
        offShelfVisible: false,
        addVisible: false,
        detailModalVisible: false,
        visibleTitle: '',
        activeRecordID: null,
        permissionList: []
    }

    reform = React.createRef<FormInstance>()

    componentDidMount() {
        this.setState({
            permissionList: getPermission()
        })

        const { pagination, fetchOtherParams } = this.state
        this.fetch({ pagination, fetchOtherParams })
    }

    handleInputChange(value: string, attr: string) {
        let { fetchOtherParams }: { fetchOtherParams: any } = this.state
        fetchOtherParams[attr] = value

        this.setState({ fetchOtherParams })
    }

    handleSearch() {
        let { pagination, fetchOtherParams } = this.state
        pagination.current = 1

        this.setState({ pagination }, () => {
            this.fetch({ pagination, fetchOtherParams })
        })
    }

    handleTableChange = (antPagination: any) => {
        const { fetchOtherParams, pagination } = this.state
        pagination.current = antPagination.current

        this.fetch({
            pagination,
            fetchOtherParams
        })
    }

    fetch({ pagination, fetchOtherParams }: { pagination: Object, fetchOtherParams: object }) {
        const iPagination: any = { ...pagination }
        iPagination.page_num = iPagination.current
        iPagination.page_size = iPagination.pageSize

        delete iPagination.current
        delete iPagination.pageSize
        delete iPagination.total

        axiosTable.get('/chankang_center/item_type/page_list', {
            params: {
                ...iPagination,
                ...fetchOtherParams
            }

        }).then((response: any) => {
            if (response) {
                const { pagination } = this.state
                pagination.total = response.total
                pagination.pageSize = response.size
                pagination.current = response.current

                this.setState({
                    pagination,
                    data: response.records
                })
            }
        })
    }

    resetForm() {
        let { pagination, fetchOtherParams } = this.state
        pagination.current = 1
        fetchOtherParams.item_type_name = undefined

        this.setState({
            pagination,
            fetchOtherParams
        })

        this.fetch({ pagination, fetchOtherParams })
    }

    showDetail() {
        this.setState({ detailModalVisible: true })
    }

    showAdd() {
        this.setState({ activeRecordID: null, addVisible: true, visibleTitle: '新增项目分类' }, () => {
            this.reform.current?.setFieldsValue({ 'remark': '' })
            this.reform.current?.setFieldsValue({ 'item_type_name': '' })
        })
    }

    showEdit(record: any) {
        baseAxiosNoInfo.get('/chankang_center/item_type/detail', { params: { item_type_id: record.item_type_id } }).then((res: any) => {
            this.setState({ addVisible: true, visibleTitle: '编辑项目分类', activeRecordID: record.item_type_id }, () => {
                this.reform.current?.setFieldsValue({ 'remark': res.remark })
                this.reform.current?.setFieldsValue({ 'item_type_name': res.item_type_name })
            })
        })
    }

    offShelf() {
        this.setState({ offShelfVisible: true })
    }

    confirmAdd(values: any) {
        let id = this.state.activeRecordID
        let postData: any = {}

        if (id) {
            postData = {
                item_type_id: this.state.activeRecordID,
                item_type_name: values.item_type_name,
                remark: values.remark,
            }

        } else {
            postData = {
                item_type_name: values.item_type_name,
                remark: values.remark,
            }
        }

        let url = id ? '/chankang_center/item_type/update' : '/chankang_center/item_type/add '

        baseAxiosComplete.post(url, postData).then((res: any) => {
            const { pagination, fetchOtherParams } = this.state
            pagination.current = 1

            this.fetch({ pagination, fetchOtherParams })
            this.setState({ addVisible: false })
        })
    }

    render() {
        let { item_type_name } = this.state.fetchOtherParams
        let permissionList = this.state.permissionList

        return (<div className="common-page">
            {/* 产康中心 -> 产康项目管理 -> 项目分类管理 */}
            <BreadCrumb position={['产康中心', '项目分类管理']} />

            <div className="common-top-form">
                <Space direction="horizontal" wrap>
                    <Input style={{ marginRight: 8, marginBottom: 12, width: '150px' }} placeholder="分类名称" onChange={(e: { target: { value: string } }) => { this.handleInputChange(e.target.value, 'item_type_name') }} value={item_type_name} />

                    {permissionList.includes('查询') && <Button style={{ marginRight: 5, marginBottom: 12 }} className="search-btn" icon={<SearchOutlined />} onClick={this.handleSearch.bind(this)} >查询</Button>}
                    <Button style={{ marginRight: 5, marginBottom: 12 }} onClick={this.resetForm.bind(this)} icon={<RedoOutlined />}>重置</Button>
                    {permissionList.includes('添加') && <Button type="primary" style={{ marginRight: 5, marginBottom: 12 }} onClick={this.showAdd.bind(this)}>添加</Button>}
                </Space>
            </div>

            <div className="common-main">
                <Table dataSource={this.state.data} scroll={{ x: 'max-content' }} bordered={true} rowKey="item_type_id" pagination={this.state.pagination} onChange={this.handleTableChange}>
                    <Column title="分类名称" dataIndex="item_type_name" key="item_type_name" />
                    <Column title="备注" dataIndex="remark" key="remark" />
                    <Column title="创建时间" dataIndex="create_time" key="create_time" />

                    <Column
                        title="操作"
                        key="action"
                        render={(text, record) => (
                            <Space size="middle">
                                {permissionList.includes('编辑') && <Button type="link" onClick={this.showEdit.bind(this, record)}>编辑</Button>}
                            </Space>
                        )}
                    />
                </Table>
            </div>

            {/* 产康中心 -> 产康项目管理 -> 项目分类 -> 新增或编辑 */}
            <Modal title={this.state.visibleTitle} visible={this.state.addVisible} footer={false} width="450px" onCancel={() => { this.setState({ addVisible: false }) }}>
                <Form {...formItemLayout} ref={this.reform} name="validate_other" onFinish={this.confirmAdd.bind(this)} >
                    <Form.Item label="分类名称" name="item_type_name" rules={[{ required: true, message: '必须填写分类名称' }]} >
                        <Input placeholder="" />
                    </Form.Item>

                    <Form.Item label="备注" name="remark" rules={[{ required: true, message: '备注' }]} >
                        <Input placeholder="" />
                    </Form.Item>

                    <Form.Item {...tailLayout}>
                        <Button type="primary" htmlType="submit">提交</Button>
                    </Form.Item>
                </Form>
            </Modal>
        </div>)
    }
}